/**
 * The short name a schedule's timezone goes by in the UI ("IST", "CST").
 *
 * Intl gets most zones right on its own, but hands back "GMT+5:30" for the
 * Indian zones, which is not what the schedule cards are meant to read like —
 * so those few are named here and everything else comes from the engine.
 */
const OVERRIDES = {
  'Asia/Kolkata': 'IST',
  'Asia/Calcutta': 'IST',
  'Asia/Colombo': 'IST',
}

export function timezoneAbbrev(timezone) {
  if (!timezone) return ''
  if (OVERRIDES[timezone]) return OVERRIDES[timezone]
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'short',
    }).formatToParts(new Date())
    return parts.find((part) => part.type === 'timeZoneName')?.value ?? ''
  } catch {
    // An unknown zone is still worth showing — the stored string beats nothing.
    return timezone
  }
}
